import React from "react"
import GeneralCard from "../components/general-card/general-card.component"
import EbookIcon from "../svg/Ebook.svg"
import TimeIcon from "../svg/Time.svg"
import VideoIcon from "../svg/Video.svg"
import CodeIcon from "../svg/NewCode.svg"

const getIcon = (iconName) => {
  switch (iconName) {
    case "book":
      return <EbookIcon style={{ fill: "#4c0ffb", stroke: "none" }} />
    case "youtube":
      return <VideoIcon />
    default:
      return <CodeIcon />
  }
}

export const getCourseData = (dataset, gtmDataLayer, cardType) => {
  return dataset.map((obj) => {
    const content = obj.node ?? obj
    const {
      authors,
      contentName,
      badge,
      subtitle,
      subtitleIcon,
      excerpt,
      buttonText,
      linkUrl,
      thumbnail,
      courseUrl,
      coursePromoUrl,
      courseTitle,
      courseExcerpt,
      courseImage,
      totalHours,
      totalLessons,
    } = content

    const cardTitle = courseTitle ?? contentName

    const cardBadge = JSON.parse(
      JSON.stringify(badge).replace("[", "").replace("]", "")
    )
    const cardUrl = courseUrl ?? linkUrl
    const cardImage = courseImage ?? thumbnail
    const cardExcerpt = courseExcerpt ?? excerpt
    const courseInfo = { coursePromoUrl, totalLessons, totalHours }
    const bonusInfo = { subtitle, subtitleIcon, buttonText }

    const timeDetails =
      cardType === "course-card" || cardType === "small-course-card" ? (
        <>
          <TimeIcon />
          {totalHours} Hours <span>•</span>
          {totalLessons} Lessons{" "}
        </>
      ) : (
        <>
          {getIcon(subtitleIcon[0])}
          {subtitle}
        </>
      )

    return (
      <GeneralCard
        authors={authors}
        key={cardTitle}
        title={cardTitle}
        badge={cardBadge}
        url={cardUrl}
        image={cardImage}
        excerpt={cardExcerpt}
        timeDetails={timeDetails}
        gtmDataLayer={gtmDataLayer}
        cardType={cardType}
        {...bonusInfo}
        {...courseInfo}
      />
    )
  })
}
